module.exports = __webpack_public_path__ + "static/ContactBG-88bd5e5279576b16c2c4232430b534fc.jpg";